<template>
    <div id="BoneAdd">
        <el-form :model="form" :rules="rules" label-width="180px" ref="form">
            <div class="title">病例信息</div>
            <el-form-item label="病例标题" prop="title">
                <el-input v-model="form.title" maxlength="25" minlength="2" placeholder="请输入病例标题（必填）" />
            </el-form-item>
            <el-form-item label="病例专业" prop="zhuan_ye">
                <el-select v-model="form.zhuan_ye" placeholder="请选择所属专业">
                    <!-- <el-option v-for="(item,index) in list" :key="index" :label="item" :value="index"></el-option> -->
                    <el-option label="关节" value="关节"></el-option>
                    <el-option label="创伤" value="创伤"></el-option>
                    <el-option label="脊柱" value="脊柱"></el-option>
                    <el-option label="运医" value="运医"></el-option>
                    <el-option label="小儿" value="小儿"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="form.gender">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄" prop="age" class="age-item">
                <el-col :span="2"> <el-input type="number" min="1" max="120" v-model="form.age"/></el-col>
                <el-col :span="1" class="sui">岁</el-col>
            </el-form-item>
            <el-form-item label="体重" prop="weight" class="age-item">
                <el-col :span="2"> <el-input type="number" min="0" max="300" step="0.1" v-model="form.weight"/></el-col>
                <el-col :span="1" class="sui">kg</el-col>
            </el-form-item>
            <div class="title">病例详情</div>
            <el-form-item label="主诉" prop="zhu_su">
                <el-input v-model="form.zhu_su" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" show-word-limit placeholder="请输入主诉（您可以输入10-50个字）" minlength="10" maxlength="50"/>
            </el-form-item>
            <el-form-item label="现病史" prop="xian_bing_shi">
                <el-input v-model="form.xian_bing_shi" type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" show-word-limit placeholder="请输入现病史（您可以输入700个字）" minlength="10" maxlength="700"/>
            </el-form-item>

            <!-- 既往用药：可动态添加的药物 + 用药时长 -->
            <el-form-item label="既往用药">
                <div class="medication-list">
                    <div v-for="(item, index) in form.medications" :key="index" class="medication-item">
                        <el-select v-model="item.name" placeholder="请选择药物" class="medication-name">
                            <el-option v-for="(drug, idx) in medicationOptions" :key="idx" :label="drug" :value="drug"></el-option>
                        </el-select>
                        <el-input v-if="item.name === '其他'" v-model="item.customName" placeholder="请填写药物名称" class="medication-duration" maxlength="50"></el-input>
                        <el-input v-model="item.duration" placeholder="请填写用药时长（如：3个月）" class="medication-duration" maxlength="50"></el-input>
                        <i class="el-icon-delete medication-delete" @click="removeMedication(index)"></i>
                    </div>
                    <el-button v-if="form.medications.length < 10" class="medication-add" type="primary" plain size="small" icon="el-icon-plus" @click="addMedication">添加用药</el-button>
                </div>
            </el-form-item>
            <!-- 体格检查 / 诊断 / 治疗经过 / 病例思考：文本描述 + 影像资料（图片最多 9 张、视频 1 个） -->
            <div class="section-block" v-for="item in sections" :key="item.field">
                <el-form-item :label="item.label" :prop="item.field">
                    <span v-if="item.template" slot="label" class="label-with-btn">
                        {{ item.label }}
                        <el-button class="template-btn" type="primary" plain size="mini" @click="showScenePicker = true">参考模板 +</el-button>
                    </span>
                    <el-input
                        v-model="form[item.field]"
                        type="textarea"
                        :autosize="{ minRows: item.rows[0], maxRows: item.rows[1] }"
                        show-word-limit
                        :placeholder="item.placeholder"
                        :minlength="item.min || 0"
                        :maxlength="item.max"
                    />
                    <!-- 模板回填提示：** 包裹处为参考建议，需按患者实际情况修改 -->
                    <div v-if="item.template && hasTemplateMark" class="template-tip">
                        <span class="template-tip-text">模板已填充，<b>**</b> 包裹处为参考内容，请结合实际修改后再提交</span>
                        <span class="template-tip-btn" @click="clearTemplateMark">去除标记</span>
                    </div>
                </el-form-item>

                <el-form-item :label="item.mediaLabel" :prop="item.media" class="user-info-list">
                    <div class="media-uploads">
                        <el-upload
                            action=""
                            accept="image/*"
                            list-type="picture-card"
                            :limit="MAX_IMAGE"
                            :on-exceed="onImageExceed"
                            :before-upload="file => checkImage(file, item.media)"
                            :on-preview="file => previewImage(file, item.media)"
                            :on-remove="param => handleRemove(param, item.media)"
                            :file-list="form[item.media]"
                            :http-request="param => beforeAvatarUpload(param, item.media)"
                        >
                            <div class="up-slot">
                                <i class="el-icon-picture-outline"></i>
                                <span>上传图片</span>
                            </div>
                        </el-upload>
                        <el-upload
                            action=""
                            accept="video/*"
                            list-type="picture-card"
                            class="video-upload"
                            :class="{ 'hide-add': hideVideoAdd(item.media), 'is-video-uploading': hasVideoUploading(item.media) }"
                            :show-file-list="false"
                            :before-upload="file => checkVideo(file, item.media)"
                            :on-preview="file => previewVideo(file, item.media)"
                            :on-remove="param => handleRemoveVideo(param, item.media)"
                            :file-list="form[videoListName(item.media)]"
                            :http-request="param => beforeVideoUpload(param, item.media)"
                        >
                            <div class="up-slot">
                                <i class="el-icon-video-camera"></i>
                                <span>上传视频</span>
                            </div>
                        </el-upload>
                        <!-- 已上传视频列表：自己渲染，避开 el-upload 内部 uploadFiles 状态机。
                             上传中再叠加 .video-uploading 占位（外层），不影响已渲染的视频卡片 -->
                        <el-tooltip
                            v-for="video in form[videoListName(item.media)] || []"
                            :key="video.uid"
                            placement="top"
                            :disabled="!video.name && !video.size && !video.duration"
                        >
                            <div slot="content">
                                <div style="max-width: 260px; word-break: break-all;">{{ video.name }}</div>
                                <div v-if="video.size">{{ formatSize(video.size) }} · {{ video.duration ? formatDuration(video.duration) : '时长解析中…' }}</div>
                            </div>
                            <div class="video-card">
                                <div
                                    class="video-card-thumb"
                                    :class="{ 'is-loading': !video.url }"
                                    :style="video.url ? { backgroundImage: 'url(' + video.url + ')' } : {}"
                                >
                                    <i v-if="!video.url" class="el-icon-video-camera"></i>
                                    <i v-else class="video-card-play" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
                                            <path d="M8 5v14l11-7z" />
                                        </svg>
                                    </i>
                                    <!-- 左下角时长徽章 -->
                                    <span v-if="video.duration" class="video-card-duration">{{ formatDuration(video.duration) }}</span>
                                    <!-- 右下角大小徽章 -->
                                    <span v-if="video.size" class="video-card-size">{{ formatSize(video.size) }}</span>
                                </div>
                                <div class="video-card-actions" @click.stop>
                                    <span class="video-card-action" @click="previewVideo(video, item.media)">预览</span>
                                    <span
                                        class="video-card-action"
                                        @click="handleRemoveVideo({ file: video, fileList: form[videoListName(item.media)] }, item.media)"
                                    >删除</span>
                                </div>
                            </div>
                        </el-tooltip>
                        <!-- 视频上传中：用本地首帧 + 进度替代 Element 默认的空白缩略图（支持多视频并行） -->
                        <div
                            v-for="up in videoUploadingList(item.media)"
                            :key="up.uid"
                            class="video-uploading"
                            :class="{ 'is-failed': up.status === 'failed', 'is-cancelable': up.status === 'uploading' }"
                        >
                            <div
                                class="video-uploading-thumb"
                                :style="up.thumb ? { backgroundImage: 'url(' + up.thumb + ')' } : {}"
                            >
                                <i v-if="!up.thumb" class="el-icon-video-camera"></i>
                            </div>
                            <div class="video-uploading-mask">
                                <!-- 成功时不显示遮罩，留空给 hover 行动条 -->
                                <template v-if="up.status === 'failed'">
                                    <i class="el-icon-warning-outline video-uploading-fail-icon"></i>
                                    <span class="video-uploading-text">上传失败</span>
                                </template>
                                <template v-else-if="up.status !== 'success'">
                                    <span class="video-uploading-percent">{{ up.percent }}%</span>
                                    <span class="video-uploading-text">
                                        {{ up.percent === 0 && !up.thumb ? '准备中…' : '视频上传中' }}
                                    </span>
                                    <!-- 详细进度：已传 MB / 总 MB（小文件 < 1MB 退化为 KB） -->
                                    <span class="video-uploading-detail" v-if="up.loaded != null && up.total">
                                        {{ formatSize(up.loaded) }} / {{ formatSize(up.total) }}
                                        <span class="video-uploading-eta" v-if="up.eta">· 剩 {{ up.eta }}</span>
                                    </span>
                                </template>
                            </div>
                            <div class="video-uploading-bar" v-if="up.status !== 'success'">
                                <i :style="{ width: up.percent + '%' }"></i>
                            </div>
                            <!-- 操作条：上传中显示取消，失败显示重试 -->
                            <div class="video-uploading-actions" @click.stop>
                                <template v-if="up.status === 'uploading'">
                                    <span class="video-uploading-action" @click="cancelVideoUpload(up, item.media)">取消</span>
                                </template>
                                <template v-else-if="up.status === 'failed'">
                                    <span class="video-uploading-action" @click="retryVideoUpload(up, item.media)">重试</span>
                                    <span class="video-uploading-action" @click="dismissVideoUpload(up, item.media)">移除</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="upload-tips">
                        <span><i class="el-icon-picture-outline"></i>{{ imageTip(item.media) }}</span>
                        <span><i class="el-icon-video-camera"></i>{{ videoTip(item.media) }}</span>
                    </div>
                </el-form-item>
            </div>

            <p class="draft-tip" v-if="draftTip">内容已自动暂存（{{ draftTip }}），退出后可继续编辑</p>
            <el-form-item size="large" class="action-bar">
                <el-button type="primary" plain :loading="submitting" @click="saveDraftNow">暂 存</el-button>
                <el-button style="background-color: #5680FA;border-color: #5680FA" type="primary" :loading="submitting" @click="submitFormVideo('form')">确 定</el-button>
                <!-- <el-button>取消</el-button> -->
            </el-form-item>
        </el-form>

        <!-- 病例思考参考模板选择 -->
        <el-dialog title="选择参考模板" :visible.sync="showScenePicker" width="620px" append-to-body>
            <div class="scene-list">
                <div v-for="(item, index) in sceneOptions" :key="index" class="scene-item" @click="selectScene(item)">
                    <span class="scene-icon-wrap"><i :class="item.icon"></i></span>
                    <span class="scene-name">{{ item.name }}</span>
                    <i class="el-icon-arrow-right scene-arrow"></i>
                </div>
            </div>
        </el-dialog>

        <!-- 图片大图预览 -->
        <el-dialog title="图片预览" :visible.sync="previewImageVisible" width="760px" append-to-body>
            <div class="media-preview">
                <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
            </div>
        </el-dialog>

        <!-- 视频播放预览 -->
        <el-dialog title="视频预览" :visible.sync="previewVideoVisible" width="760px" append-to-body @closed="previewVideoUrl = ''">
            <div class="media-preview">
                <video v-if="previewVideoUrl" :src="previewVideoUrl" controls autoplay preload="metadata"></video>
                <p v-else class="media-preview-empty">视频正在处理中，暂无法预览</p>
            </div>
        </el-dialog>

        <!-- 发布成功：提示扫码到手机端查看 -->
        <el-dialog
            :visible.sync="publishSuccessVisible"
            width="420px"
            append-to-body
            custom-class="publish-dialog"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @closed="afterPublishSuccess"
        >
            <div class="publish-success">
                <div class="publish-success-icon">
                    <i class="el-icon-check"></i>
                </div>
                <h3 class="publish-success-title">发布成功</h3>
                <p class="publish-success-tip">病例详情请在手机端查看</p>
                <div class="publish-success-qr">
                    <VueQr
                        v-if="mobileLink"
                        draggable="false"
                        :correctLevel="3"
                        :dotScale="1"
                        :logoSrc="qrLogo"
                        :margin="15"
                        :size="200"
                        :text="mobileLink"
                    />
                </div>
                <p class="publish-success-qr-tip">请使用手机扫码观看病例详情</p>
                <el-button class="publish-success-btn" type="primary" @click="publishSuccessVisible = false">我知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import VueQr from "vue-qr";
/* OSS 直传 + 智能图片压缩 + 视频首帧截取，对齐 bonetoday_wechat_sub 项目的发布逻辑 */
import ossUploader from "@/utils/oss";
import { smartCompress } from "@/utils/smartCompress";
import { captureVideoCover, coverToFile } from "@/utils/videoCover";

export default {
    name: "BoneAdd",
    components: { VueQr },
    data() {
        return {
            gid: sessionStorage.getItem("l-gid") || "",
            pic: "",
            list: ["关节", "创伤", "脊柱", "运医", "小儿", "其他"],
            /* 图片地址前缀（根据 imgGid 拼接），与 H5 端 /SD/common/picSelect?gid= 保持一致 */
            picStr: "https://www.orthoday.com/SD/common/picSelect?gid=",
            /* 视频上传接口：与 H5 端一致，POST /SD/common/movieUpload，字段 multipartFile，返回 OSS 地址 */
            movieUploadUrl: "/SD/common/movieUpload",
            /* 视频较大，接口超时放宽到 10 分钟 */
            movieUploadTimeout: 10 * 60 * 1000,
            /* 上传限制 */
            MAX_IMAGE: 9 /* 每个模块最多 9 张图片 */,
            MAX_VIDEO: 2 /* 每个模块最多 2 个视频 */,
            MAX_IMAGE_SIZE: 10 * 1024 * 1024 /* 单张图片 10MB */,
            /* 单个视频上限 500MB：服务端（nginx）请求体限制放宽到 500M，超出则直接 413，
               前端提前拦截，避免用户传完 500M 才收到失败提示 */
            MAX_VIDEO_SIZE: 500 * 1024 * 1024,
            /* 提交中：防止重复点击 */
            submitting: false,
            /* 登录校验未通过（未登录 / token 失效 / 未认证）：阻止草稿恢复等后续逻辑 */
            authBlocked: false,
            /* 图片 / 视频预览 */
            previewImageVisible: false,
            previewImageUrl: "",
            previewVideoVisible: false,
            previewVideoUrl: "",
            /* 视频时长缓存：{ [uid]: 12.3 } 视频上传成功后读 duration 写进 form 列表，hover 时显示 */
            videoDurationCache: {},
            /* 视频上传中的占位信息：{ [上传框名]: { [uid]: { percent, thumb, status, loaded, total, eta, file, abort } } }。
               - status: 'uploading' / 'failed' / 'success' / 'canceled'
               - file/abort 缓存原 File 与取消句柄，用于"重试"和"取消" */
            videoUploads: {},
            /* 发布成功弹框 */
            publishSuccessVisible: false,
            /* 手机端病例详情链接，用于生成扫码二维码 */
            mobileLink: "https://www.orthoday.com/bone",
            /* 二维码中心 logo，与 PopUpWin 保持一致 */
            qrLogo: require("../../assets/img/v_logo.png"),
            /* 四个「文本 + 影像资料」模块：配置化渲染，避免重复 4 段相同模板 */
            sections: [
                {
                    label: "体格检查/辅助检查",
                    field: "jian_cha",
                    media: "jc_list",
                    mediaLabel: "",
                    rows: [3, 8],
                    max: 700,
                    placeholder: "请输入体格检查/辅助检查结果，上传相应影像资料（您可以输入700个字）"
                },
                {
                    label: "诊断",
                    field: "zhen_duan",
                    media: "zd_list",
                    mediaLabel: "患者相关的影像资料补充:",
                    rows: [3, 8],
                    max: 700,
                    placeholder: "请输入诊断内容（您可以输入700个字）"
                },
                {
                    label: "治疗经过",
                    field: "zljg",
                    media: "zljg_list",
                    mediaLabel: "",
                    rows: [3, 8],
                    max: 1000,
                    placeholder: "请描述手术记录与患者术后康复治疗经过等（您可以输入1000个字）"
                },
                {
                    label: "病例思考",
                    field: "blsk",
                    media: "blsk_list",
                    mediaLabel: "",
                    rows: [4, 12],
                    max: 700,
                    placeholder: "系统性回顾患者收治全过程，对诊疗过程进行总结（您可以输入700个字）",
                    template: true
                }
            ],
            /* 病例思考「参考模板」 */
            showScenePicker: false,
             sceneOptions: [
                {
                    name: '术前提高骨质量',
                    icon: 'records-o',
                    color: '#5680fa',
                    template:
                        '该患者经评估提示 **L1椎体CT值≤110 HU，DXA检查确诊重度骨质疏松（T值≤-3.0，** 结合影像学表现，为防止患者术后出现 **椎弓根螺钉把持力不足，愈合延迟，或者植骨不融合。** 依据 **《老年骨质疏松症患者胸腰椎内固定临床应用指南（2025 版）》《老年骨质疏松性胸腰段椎体骨折伴后凸畸形诊疗指南 (2024 版)》《中国老年骨质疏松症诊疗指南（2023）》及《髋膝关节置换患者骨质疏松管理专家共识 (2025 年版)》**，**在排除用药禁忌后予特立帕肽行促成骨治疗。考虑到患者为老年人群，周制剂给频次低，保障足疗程规范化治疗，快速改善椎体骨微结构、提升骨强度。予以注射用重组特立帕肽56.5μg/周，建议术前规范应用**2-6个月**。\n\n疗效循证方面，中国多中心Ⅲ期研究显示，周制剂治疗48周腰椎骨密度提升约5%，优效于阿仑膦酸钠，为围术期椎体骨质量优化提供循证支撑。\n\n特立帕肽作为合成代谢类药物，可主动促进新骨生成，有效优化术前骨小梁微结构，可使椎弓根螺钉植入扭矩提升15%~20%，显著增强螺钉把持力；同时可有效提升腰椎骨密度、强化椎体力学强度，降低术后螺钉松动、内固定失效及远期再骨折风险。相较于传统日制剂，周制剂给药更简便，更利于老年患者坚持足疗程治疗，充分发挥围术期骨优化疗效，改善患者手术预后。'
                },
                {
                    name: '术后加速愈合',
                    icon: 'bell',
                    color: '#5680fa',
                    template:
                        '该患者既往有椎体压缩性骨折病史，经评估提示 **DXA检查确诊骨质疏松（T值≤-2.5）,术中手感松**，结合影像学表现预判**老年骨松基础下术后骨重塑能力偏弱，存在骨修复速度慢、愈合时间长，远期继发再骨折的高危临床特点**。依据**《老年骨质疏松性胸腰椎压缩骨折经皮椎体强化术术后椎体再骨折诊疗指南（2025 版）》《腰椎融合内固定患者骨质疏松相关并发症预防指南 (2024 版)》《老年骨质疏松性胸腰段椎体骨折伴后凸畸形诊疗指南 (2024 版)》《中国老年骨质疏松症诊疗指南（2023）》**，在排除用药禁忌后予特立帕肽行促骨形成治疗。考虑到患者为老年术后康复人群，周制剂注射频次低，可有效规避长期反复给药带来的依从性下降问题，保障术后足疗程规范干预，持续促进术后骨骼重塑修复、改善椎体生物力学功能。予以注射用重组特立帕肽56.5μg/周，**建议规范应用时长（3个月／6个月／1年／1年半／2年）。**\n\n疗效循证层面，2020年Meta分析显示，应用特立帕肽，可显著缩短髋部骨折愈合时间近2周。2017年一项RCT显示，特立帕肽周制剂治疗6个月，显著提高椎间融合率近1倍。愈合时间缩短、愈合率提高，为加速术后骨骼修复重建提供确证依据。\n\n持续治疗率层面，相较于传统日制剂，周制剂更便捷的给药模式更适配老年患者术后长期康复管理，有助于降低长期注射带来的治疗负担，有效规避中途停药、断疗情况，持续稳定地发挥术后促骨修复、缓解疼痛、防控再骨折的综合治疗作用，助力患者完成骨骼修复重建，显著提升术后整体康复质量。'
                },
                {
                    name: '骨质疏松性骨折促愈合',
                    icon: 'replay',
                    color: '#5680fa',
                    template:
                        '该患者近期发生 **骨质疏松性椎体压缩骨折（OVCF），DXA检查确诊骨质疏松（T值≤-2.5）**，结合影像学表现预判**骨松骨折后骨修复能力减弱，骨折不愈合发生率高，愈合时间延长，存在远期再骨折风险**。依据**《骨质疏松性椎体压缩骨折诊治专家共识（2021年版）》、《骨质疏松性骨折诊疗指南（2022年版）》**，在排除用药禁忌后予特立帕肽行促骨形成治疗。考虑到骨松骨折愈合周期长、需长期持续药物干预，周制剂注射频次低、依从性更高，可保障加速愈合与全程规律用药。予以注射用重组特立帕肽56.5μg/周，建议规范**应用时长（3个月／6个月／1年／1年半／2年）**。\n\n疗效循证层面，Lancet子刊2026年系统评价与荟萃分析显示，特立帕肽显著缩短骨折愈合时间3.03周；2020年Meta分析显示，应用特立帕肽，可显著缩短髋部骨折愈合时间近2周，为骨松骨折患者促进愈合提供确证依据。\n\n持续治疗率层面，相较于传统日制剂，周制剂每周仅需注射1次、给药更便捷，真实世界数据显示其1年持续治疗率约为日制剂的1.8倍，可有效保障骨松骨折愈合关键期的全程规律用药，持续发挥促骨愈合、缓解疼痛、防控再骨折的综合治疗作用。'
                },
                {
                    name: '严重骨松患者提高骨密度',
                    icon: 'apps-o',
                    color: '#5680fa',
                    template:
                        '该患者经评估提示 **L1椎体CT值50~80 HU，DXA检查确诊骨质疏松（T值≤-2.5），合并脆性骨折**，结合影像学表现预判**骨微结构严重受损、骨量丢失明显，属于极高脆性骨折复发高危人群，远期骨骼失稳、反复骨折风险升高**。依据**《2024年美国骨矿盐协会目标导向治疗立场声明》**推荐，在排除用药禁忌后予特立帕肽行促骨形成治疗。考虑到重度骨质疏松骨重建周期长，周制剂给药间隔长、注射频次低，减少长期反复注射造成的身心压力，保障骨量重建阶段持续规范用药，予以注射用重组特立帕肽56.5μg/周，**建议规范应用时长（3个月／6个月／1年／1年半／2年）**。\n\n疗效循证层面，中国多中心Ⅲ期研究显示，周制剂治疗48周腰椎骨密度提升约5%、优效于阿仑膦酸钠，全髋骨密度提升3.27%、约为阿仑膦酸钠组的2倍，新发临床骨折例数下降60%，骨量提升更快、更优，脆性骨折风险防控更有据可依。\n\n持续治疗率层面，相较于传统日制剂，周制剂给药模式适配重度骨质疏松长周期骨重建治疗需求，可减少频繁给药引发的治疗中断，稳定发挥促骨形成、改善骨质量、防控脆性骨折的综合治疗作用，助力完成骨骼重建，改善患者远期骨骼健康状态。'
                }
            ],
            /* 既往用药：可选药物下拉列表 */
            medicationOptions: [
                "注射用特立帕肽注射液（日制剂）",
                "注射用重组特立帕肽（周制剂）",
                "地舒单抗",
                "阿仑膦酸钠片",
                "唑来膦酸注射液",
                "其他"
            ],
            /* 暂存（草稿）相关 */
            draftKey: "",
            draftTimer: null,
            draftTip: "",
            draftCleared: false,
            form: {
                title: "" /* 标题 */,
                gender: "男" /* 性别 */,
                age: "" /* 年龄 */,
                weight: "" /* 体重（kg） */,
                zhuan_ye: "" /* 专业 */,
                zhu_su: "" /* 主诉 */,
                xian_bing_shi: "" /* 现病史 */,
                medications: [] /* 既往用药：{ name, duration } */,
                jian_cha: "" /* 体格检查/辅助检查 */,
                jc_list: [] /* 图片 { imgGid: "" } */,
                jc_list_File: [] /* { imgGid: "" } */,
                jc_videoList: [] /* 视频（每个模块 1 个）{ videoUrl: 视频 OSS 地址, coverUrl: 封面 OSS 地址, url: 首帧缩略图（兜底用） } */,

                zhen_duan: "" /* 诊断 */,
                zd_list: [],
                zd_list_File: [] /* { imgGid: "" } */,
                zd_videoList: [],
                zljg: "" /* 治疗经过 */,
                zljg_list: [],
                zljg_list_File: [] /* { imgGid: "" } */,
                zljg_videoList: [],
                blsk: "" /* 病例思考 */,
                blsk_list: [],
                blsk_list_File: [] /* { imgGid: "" } */,
                blsk_videoList: []
            },
            rules: {
                title: [{ required: true, message: "标题内容不少于2个字", trigger: "blur" }],
                age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
                weight: [
                    { required: true, message: "请输入体重", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) return callback();
                            let n = Number(value);
                            if (Number.isNaN(n) || n <= 0 || n > 300) {
                                callback(new Error("体重请填写 0-300 之间的数值（kg）"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ],

                zhuan_ye: [
                    {
                        required: true,
                        message: "请选择专业",
                        trigger: "change"
                    }
                ],
                gender: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                zhu_su: [{ required: true, message: "主诉内容不少于10个字", trigger: "blur" }],
                xian_bing_shi: [{ required: true, message: "现病史内容不少于10个字", trigger: "blur" }],
                jian_cha: [{ required: true, message: "请输入体格检查/辅助检查结果", trigger: "blur" }],
                // 影像/视频资料均改为非必填：jc_list / zd_list / zljg_list / blsk_list 不再设置校验规则
                zhen_duan: [{ required: true, message: "请输入诊断内容", trigger: "blur" }],
                zljg: [{ required: true, message: "请输入治疗经过", trigger: "blur" }],
                blsk: [{ required: true, message: "请输入病例思考", trigger: "blur" }]
            },
            boneInfo: [
                {
                    title: "" /* 标题 */,
                    detail: "" /* 现病史 */,
                    lstPic: "",
                    lstVid: "",
                    type: 0
                },
                {
                    detail: "" /* 诊断 */,
                    pic: [],
                    vid: "",
                    age: "",
                    gender: "",
                    type: 1
                },
                {
                    detail: "" /* 治疗经过 */,
                    pic: [],
                    vid: "",
                    age: "",
                    gender: "",
                    type: 2
                },
                {
                    detail: "" /* 病例思考 */,
                    pic: [],
                    vid: "",
                    age: "",
                    gender: "",
                    type: 3
                },
                { detail: "" /* 关节 */, type: 4 },
                {
                    detail: "" /* 主诉 */,
                    pic: "",
                    vid: "",
                    age: "",
                    gender: "",
                    type: 5
                },
                {
                    detail: "" /* 体格检查/辅助检查 */,
                    pic: [],
                    vid: "",
                    age: "",
                    gender: "",
                    type: 6
                },
                {
                    detail: "" /* 既往用药 */,
                    pic: "",
                    vid: "",
                    age: "",
                    gender: "",
                    type: 8
                },
                {
                    detail: "" /* 体重（kg） */,
                    pic: "",
                    vid: "",
                    age: "",
                    gender: "",
                    type: 9
                }
            ] /* 提交数据格式 */

            // 图片
            // dialogImageUrl: "",
            // dialogVisible: false,
        };
    },
    computed: {
        userId() {
            return localStorage.getItem("userId") || "";
        },
        token() {
            return localStorage.getItem("token") || "";
        },
        // 病例思考中是否还残留模板标记 **（存在说明仍有参考内容需要确认）
        hasTemplateMark() {
            return !!this.form.blsk && this.form.blsk.indexOf("**") !== -1;
        }
    },
    created() {
        this.gId = this.$route.params.gId || "";
        // 暂存（草稿）存储键：按用户区分，避免不同账号互相覆盖
        this.draftKey = "boneAddDraft_" + (this.userId || "guest");
        // 进入页面时进行登录 / 认证校验
        this.checkAuth();
    },
    mounted() {
        /* 是否恢复暂存内容放到登录校验通过之后（见 checkAuth），
           否则登录已失效时会先弹出恢复弹框、再被跳去登录页，弹框会残留在登录页 */
        // 切到后台 / 关闭页面时立即落盘，避免内容丢失
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        window.addEventListener("pagehide", this.saveDraft);
        window.addEventListener("beforeunload", this.saveDraft);
    },
    beforeDestroy() {
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
        window.removeEventListener("pagehide", this.saveDraft);
        window.removeEventListener("beforeunload", this.saveDraft);
        if (this.draftTimer) clearTimeout(this.draftTimer);
        // 离开页面时兜底保存一次
        this.saveDraft();
    },
    watch: {
        // 表单任意字段变化都触发（已做防抖）暂存
        form: {
            handler() {
                this.scheduleSaveDraft();
            },
            deep: true
        }
    },
    methods: {
        /*
         * 进入页面时校验登录态是否有效 & 认证状态
         * 本地无 token / token 已失效（服务端返回「登录无效」）-> 跳转登录页，登录后回到本页面
         * 未认证 -> 跳转认证页，认证后回到本页面
         */
        checkAuth() {
            let redirect = this.$route.fullPath;
            // 1.本地就没有登录信息，直接去登录页
            if (!this.userId || !this.token) {
                this.authBlocked = true;
                return this.toLogin("您未登录，请先登录后再发布病例！", redirect);
            }
            // 2.带 token 向服务端确认登录是否仍然有效（token 过期 / 被踢下线会返回「登录无效」），同时取认证状态
            this.$axios
                .post("/web/user/select", this.$qs.stringify({ chGid: "", userSelectGid: this.userId }))
                .then(res => {
                    let data = res.data || {};
                    /* 拿不到用户信息说明本地登录态已失效：清掉本地信息回登录页，
                       避免用户辛苦填完整个表单、点发布才收到「发布失败登录无效」 */
                    if (String(data.code) !== "1") {
                        this.authBlocked = true;
                        return this.toLogin(
                            /登录无效|未登录|登录过期|登录已失效/i.test(String(data.message || ""))
                                ? "登录已失效，请重新登录！"
                                : "登录状态异常，请重新登录！",
                            redirect
                        );
                    }
                    let userInfo = data.result_data[0] || {},
                        status = userInfo.approveStatus || 0;
                    // 同步本地认证状态
                    localStorage.setItem("isConfirm", status);
                    // 0:未认证  1:认证中  2:已认证
                    if (status == 0) {
                        this.authBlocked = true;
                        this.$message.error({
                            forbidClick: true,
                            message: "您尚未认证，请先认证后再发布病例！",
                            overlay: true
                        });
                        setTimeout(() => {
                            this.$router.replace({ path: "/register", query: { redirect } });
                        }, 1500);
                        return;
                    }
                    // 3.登录有效且已认证：询问是否恢复上次未提交的暂存内容
                    this.restoreDraft();
                })
                .catch(() => {
                    // 网络异常无法确认登录态，不强制跳登录，允许继续编辑
                    this.$message.error("网络错误！");
                    this.restoreDraft();
                });
        },
        // 服务端返回的提示是否表示登录失效（token 过期 / 未登录）
        isLoginInvalid(data) {
            let d = data || {};
            return String(d.code) !== "1" && /登录无效|未登录|登录过期|登录已失效/i.test(String(d.message || ""));
        },
        // 统一跳转登录页：带上回跳地址，登录成功后回到本页继续发布
        toLogin(message, redirect) {
            // 本地登录信息已不可用，先清掉
            this.clearLoginInfo();
            this.$message.error({ forbidClick: true, message, overlay: true });
            setTimeout(() => {
                /* 清除其它页面（直播预约 / 课程播放）遗留的回跳标记。
                   登录页一旦读到它就会执行 router.go(-1) 并忽略 redirect 参数，
                   而这里是 replace 跳走、history 中已无本页，go(-1) 会退回首页，
                   导致登录后回不到发布病例页 */
                sessionStorage.removeItem("RedirectPage");
                this.$router.replace({ path: "/login", query: { redirect } });
            }, 1500);
        },
        // 清掉本地登录信息，避免带着失效 token 继续发请求
        clearLoginInfo() {
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("isConfirm");
            sessionStorage.removeItem("userAvatar");
        },

        /* ---------------- 病例思考：参考模板 ---------------- */
        // 选中模板后回填到病例思考
        selectScene(item) {
            this.form.blsk = item.template;
            this.showScenePicker = false;
            this.$message({
                message: "模板已填充，** 包裹处为参考内容，请结合实际修改",
                type: "success"
            });
        },
        // 既往用药：添加一条用药记录
        addMedication() {
            this.form.medications.push({ name: "", customName: "", duration: "" });
        },
        // 既往用药：删除指定用药记录
        removeMedication(index) {
            this.form.medications.splice(index, 1);
        },
        // 既往用药：判断某条记录是否完全空白（提交时会被过滤掉）
        isEmptyMedication(item) {
            let row = item || {};
            return !String(row.name || "").trim() && !String(row.customName || "").trim() && !String(row.duration || "").trim();
        },
        // 既往用药：过滤完全空白条目，「其他」取手填名称，组装为 { name, duration } 数组
        buildMedications() {
            let list = this.form.medications || [];
            let out = [];
            list.forEach(row => {
                let item = row || {};
                if (this.isEmptyMedication(item)) return; // 完全空白的条目直接丢弃
                // 选择「其他」时使用用户手填的药物名称
                let name = item.name === "其他" ? String(item.customName || "").trim() : String(item.name || "").trim();
                out.push({ name, duration: String(item.duration || "").trim() });
            });
            return out;
        },
        // 既往用药：提交前校验，返回错误提示文案（校验通过返回空串）
        validateMedications() {
            let list = this.form.medications || [];
            for (let i = 0; i < list.length; i++) {
                let item = list[i] || {};
                if (this.isEmptyMedication(item)) continue; // 空白条目会被过滤，不做校验
                if (!String(item.name || "").trim()) return "请选择既往用药的药物名称";
                if (item.name === "其他" && !String(item.customName || "").trim()) return "请填写既往用药中“其他”药物的名称";
                if (!String(item.duration || "").trim()) return "请选择既往用药的用药时长";
            }
            return "";
        },
        // 一键去除 ** 模板标记
        clearTemplateMark() {
            this.form.blsk = (this.form.blsk || "")
                .replace(/\s*\*\*\s*/g, "")
                .replace(/ {2,}/g, " ");
            this.$message({
                message: "已去除模板标记",
                type: "success"
            });
        },

        /* ---------------- 暂存（草稿） ---------------- */
        // 草稿里是否有值得恢复的内容
        hasContent(info) {
            if (!info) return false;
            // gender 默认「男」，不能作为有内容的依据
            let texts = ["title", "age", "zhuan_ye", "zhu_su", "xian_bing_shi", "jian_cha", "zhen_duan", "zljg", "blsk"];
            for (let i = 0; i < texts.length; i++) {
                if (info[texts[i]]) return true;
            }
            if (info.medications && info.medications.some(item => item.name || item.customName || item.duration)) return true;
            let lists = ["jc_list", "zd_list", "zljg_list", "blsk_list", "jc_videoList", "zd_videoList", "zljg_videoList", "blsk_videoList"];
            for (let i = 0; i < lists.length; i++) {
                if (info[lists[i]] && info[lists[i]].length) return true;
            }
            return false;
        },
        // 防抖保存，避免输入过程中频繁读写本地存储
        scheduleSaveDraft() {
            if (this.draftTimer) clearTimeout(this.draftTimer);
            this.draftTimer = setTimeout(() => {
                this.saveDraft();
            }, 800);
        },
        /*
         * 存草稿前做瘦身：
         * 1. 去掉不能序列化的原始文件对象（_File 数组）
         * 2. 图片本地预览地址刷新后失效，改用 imgGid 重新拼接
         * 3. 未上传成功的项（没有 imgGid）无法恢复，不写入
         */
        trimDraftInfo(info) {
            let out = {};
            if (!info) return out;
            Object.keys(info).forEach(key => {
                let val = info[key];
                if (Array.isArray(val)) {
                    // 既往用药是纯文本结构（无 imgGid），单独按原样保存，避免被下面的图片裁剪逻辑清空
                    if (key === "medications") {
                        out[key] = val.map(row => {
                            let item = row || {};
                            return {
                                name: String(item.name || ""),
                                customName: String(item.customName || ""),
                                duration: String(item.duration || "")
                            };
                        });
                        return;
                    }
                    out[key] = val
                        .map(item => {
                            if (item && typeof item === "object") {
                                let gid = item.imgGid || "";
                                if (!gid) return null;
                                if (item.isVideo) {
                                    // 视频三段地址都要存：
                                    //   videoUrl - 视频 OSS 公开地址（提交给后端的 vid）
                                    //   coverUrl - 封面 OSS 公开地址（草稿恢复时直接用，体积小）
                                    //   url      - 首帧 dataURL（OSS 不可达时兜底）
                                    return {
                                        name: item.name || "video",
                                        uid: item.uid,
                                        status: "success",
                                        isVideo: true,
                                        videoUrl: item.videoUrl || gid,
                                        coverUrl: item.coverUrl || "",
                                        imgGid: gid,
                                        url: item.coverUrl || (item.url && String(item.url).indexOf("data:") === 0 ? item.url : "")
                                    };
                                }
                                return {
                                    name: item.name || "image",
                                    uid: item.uid,
                                    status: "success",
                                    imgGid: gid,
                                    url: this.picStr + gid
                                };
                            }
                            return null;
                        })
                        .filter(item => item !== null);
                } else {
                    out[key] = val;
                }
            });
            return out;
        },
        saveDraft() {
            // 登录已失效时正在跳转登录页，不要动草稿（避免把该账号原有草稿清掉）
            if (this.authBlocked || this.draftCleared || !this.draftKey) return;
            try {
                if (!this.hasContent(this.form)) {
                    localStorage.removeItem(this.draftKey);
                    this.draftTip = "";
                    return;
                }
                localStorage.setItem(this.draftKey, JSON.stringify({ savedAt: Date.now(), form: this.trimDraftInfo(this.form) }));
                this.draftTip = this.currentTimeText();
            } catch (e) {
                // 仍超限则去掉视频缩略图，优先保证文字内容不丢
                try {
                    let simple = this.trimDraftInfo(this.form);
                    ["jc_videoList", "zd_videoList", "zljg_videoList", "blsk_videoList"].forEach(k => {
                        if (Array.isArray(simple[k])) {
                            simple[k] = simple[k].map(i => ({
                                videoUrl: (i && i.videoUrl) || "",
                                coverUrl: (i && i.coverUrl) || "",
                                imgGid: (i && i.imgGid) || "",
                                isVideo: true,
                                status: "success"
                            }));
                        }
                    });
                    localStorage.setItem(this.draftKey, JSON.stringify({ savedAt: Date.now(), form: simple }));
                    this.draftTip = this.currentTimeText();
                } catch (e2) {
                    console.warn("草稿保存失败", e2);
                }
            }
        },
        currentTimeText() {
            let d = new Date();
            return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        },
        // 手动点击「暂存」：不做必填 / 字数校验，随时可保存
        saveDraftNow() {
            if (this.submitting) return;
            if (this.draftTimer) clearTimeout(this.draftTimer);
            if (!this.hasContent(this.form)) {
                return this.$message.warning("还没有填写内容");
            }
            this.saveDraft();
            this.$message({
                message: "已暂存，可随时回来继续编辑",
                type: "success"
            });
        },
        // 清空草稿（发布成功后调用）
        clearDraft() {
            if (this.draftTimer) clearTimeout(this.draftTimer);
            this.draftCleared = true;
            try {
                localStorage.removeItem(this.draftKey);
            } catch (e) {}
            this.draftTip = "";
        },
        // 进入发布流程：暂停草稿，避免发布失败后草稿与已提交内容不一致
        pauseDraft() {
            if (this.draftTimer) clearTimeout(this.draftTimer);
            this.draftCleared = true;
            this.draftTip = "";
            try {
                localStorage.removeItem(this.draftKey);
            } catch (e) {}
        },
        // 发布失败时恢复草稿功能
        resumeDraft() {
            this.draftCleared = false;
            this.saveDraft();
        },
        formatDraftTime(t) {
            let diff = Date.now() - t;
            if (diff < 60 * 1000) return "刚刚";
            if (diff < 60 * 60 * 1000) return Math.floor(diff / 60000) + "分钟前";
            if (diff < 24 * 3600 * 1000) return Math.floor(diff / 3600000) + "小时前";
            let d = new Date(t);
            return d.getMonth() + 1 + "月" + d.getDate() + "日";
        },
        restoreDraft() {
            // 未登录 / 登录已失效时不做处理（此时正经跳转登录页）
            if (this.authBlocked || !this.userId || !this.token) return;
            let raw = "";
            try {
                raw = localStorage.getItem(this.draftKey) || "";
            } catch (e) {
                return;
            }
            if (!raw) return;
            let draft = null;
            try {
                draft = JSON.parse(raw);
            } catch (e) {
                localStorage.removeItem(this.draftKey);
                return;
            }
            if (!draft || !this.hasContent(draft.form)) {
                localStorage.removeItem(this.draftKey);
                return;
            }
            // 超过 3 天的草稿自动丢弃
            if (!draft.savedAt || Date.now() - draft.savedAt > 3 * 24 * 3600 * 1000) {
                localStorage.removeItem(this.draftKey);
                return;
            }
            let timeTxt = draft.savedAt ? this.formatDraftTime(draft.savedAt) : "";
            this.$confirm((timeTxt ? "检测到" + timeTxt + "未发布的" : "检测到上次未发布的") + "病例内容，是否继续编辑？", "提示", {
                confirmButtonText: "继续编辑",
                cancelButtonText: "清空重填",
                type: "warning"
            })
                .then(() => {
                    this.form = Object.assign({}, this.form, draft.form);
                    this.draftTip = this.currentTimeText();
                    this.$message({
                        message: "已恢复上次填写的内容",
                        type: "success"
                    });
                    this.$nextTick(() => {
                        if (this.$refs.form) this.$refs.form.clearValidate();
                    });
                })
                .catch(() => {
                    // 用户选择「清空重填」：只删掉本地草稿，保持后续仍可自动暂存
                    try {
                        localStorage.removeItem(this.draftKey);
                    } catch (e) {}
                    this.draftTip = "";
                    this.draftCleared = false;
                });
        },
        onVisibilityChange() {
            if (document.hidden) this.saveDraft();
        },
        submitFormVideo() {
            // 防重复提交
            if (this.submitting) return;
            // 还有视频在上传，此时提交会丢掉该视频
            if (Object.keys(this.videoUploads).length) {
                return this.$message.warning("视频正在上传中，请等待上传完成后再提交");
            }
            // 年龄需在 1~120 之间：type=number 的 min/max 挡不住手输的 0 / 负数 / 超大值
            let ageNum = Number(this.form.age);
            if (!ageNum || ageNum < 1 || ageNum > 120 || String(ageNum).indexOf(".") !== -1) {
                this.$message({
                    message: "年龄请填写 1-120 之间的整数",
                    type: "warning"
                });
                return;
            }

            // 判断是否登录（本地信息缺失时同样去登录页，并带上回跳地址）
            if (!(this.userId && this.token)) {
                this.authBlocked = true;
                return this.toLogin("您未登录，请登录账号再发布病例！", this.$route.fullPath);
            }

            this.$refs.form.validate((valid, invalidFields) => {
                if (!valid) {
                    this.$message.warning("请完善必填内容后再提交");
                    this.scrollToFirstError(invalidFields);
                    return false;
                }

                // 既往用药校验（场景化文案）
                let medicationError = this.validateMedications();
                if (medicationError) {
                    this.$message.warning(medicationError);
                    return false;
                }

                this.submitting = true;

                // 开始发布：先暂停草稿（失败时会再恢复），避免草稿与已提交内容不一致
                this.pauseDraft();

                // 保存 loading 实例：this.$loading().close() 会新建并关闭另一个实例，导致遮罩残留
                let publishLoading = this.$loading({
                    background: "rgba(0, 0, 0, 0.7)",
                    text: "发布中..."
                });

                let {
                    title,
                    gender,
                    age,
                    weight,
                    zhuan_ye,
                    zhu_su,
                    xian_bing_shi,
                    jian_cha,
                    jc_list,
                    zhen_duan,
                    zd_list,
                    zljg,
                    zljg_list,
                    blsk,
                    blsk_list
                } = this.form;

                // 既往用药：过滤空白 + 「其他」取手填名，每条「名称,时长」分号分条，作为 type 8 的 detail 提交
                // 注意：detail 会被后端强转 String，不能是 JSON 数组文本（曾触发 net.sf.json JSONArray 强转异常）
                let medications = this.buildMedications();
                let medicationDetail = medications.length ? medications.map(d => d.name + "," + d.duration).join(";") : "";

                // 与 wechat_sub 一致：把 undefined/null 归一化为空串，避免提交字符串 "null" / "undefined"
                const strVal = v => (v === undefined || v === null ? "" : String(v));

                let params = [];

                let changeArray = arr => {
                    if (!!arr.length) {
                        let tmp = [];
                        arr.map(item => tmp.push(item.imgGid));
                        return tmp.join();
                    }
                    return "";
                };

                this.boneInfo.map(item => {
                    switch (Number(item.type)) {
                        case 0 /* 基本信息 */:
                            params.push({
                                title,
                                detail: xian_bing_shi,
                                lstPic: "",
                                lstVid: "",
                                type: "0",
                                collegeGid: ""
                            });
                            break;
                        case 1 /* 诊断 */:
                            params.push({
                                detail: zhen_duan,
                                pic: changeArray(zd_list),
                                vid: this.vidOf("zd_list"),
                                age: String(age),
                                gender,
                                type: "1"
                            });
                            break;
                        case 2 /* 治疗经过 */:
                            params.push({
                                detail: zljg,
                                pic: changeArray(zljg_list),
                                vid: this.vidOf("zljg_list"),
                                age: String(age),
                                gender,
                                type: "2"
                            });
                            break;
                        case 3 /* 病例思考 */:
                            params.push({
                                detail: blsk,
                                pic: changeArray(blsk_list),
                                vid: this.vidOf("blsk_list"),
                                age: String(age),
                                gender,
                                type: "3"
                            });
                            break;
                        case 4 /* 专业 */:
                            params.push({ detail: zhuan_ye, type: "4" });
                            break;
                        case 5 /* 主诉 */:
                            params.push({
                                detail: zhu_su,
                                pic: "",
                                vid: "",
                                age: String(age),
                                gender,
                                type: "5"
                            });
                            break;
                        case 6 /* 体格检查/辅助检查 */:
                            params.push({
                                detail: jian_cha,
                                pic: changeArray(jc_list),
                                vid: this.vidOf("jc_list"),
                                age: String(age),
                                gender,
                                type: "6"
                            });
                            break;
                        case 8 /* 既往用药：detail 为「名称,时长」分号分条的普通文本 */:
                            if (!medicationDetail) break; // 没有用药时不提交 type 8 子帖
                            params.push({
                                detail: medicationDetail,
                                pic: "",
                                vid: "",
                                age: strVal(age),
                                gender: strVal(gender),
                                type: "8"
                            });
                            break;
                        case 9 /* 体重（kg），必填 */:
                            params.push({
                                detail: strVal(weight),
                                pic: "",
                                vid: "",
                                age: strVal(age),
                                gender: strVal(gender),
                                type: "9"
                            });
                            break;
                    }
                });

                let data = { resultList: JSON.stringify(params) },
                    headers = {
                        equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                        phoneModel: "", //手机型号
                        appVersionNumber: "" //app版本号
                    };

                this.$axios
                    .post("/SD/channel/addMedicalRecord", this.$qs.stringify(data), {
                        headers
                    })
                    .then(res => {
                        publishLoading.close();
                        this.submitting = false;
                        if (res.data.code == 1) {
                            // 发布成功：清空暂存内容，并提示到手机端查看
                            this.clearDraft();
                            this.publishSuccessVisible = true;
                        } else if (this.isLoginInvalid(res.data)) {
                            /* 提交时才发现登录失效（例如在别处登录被踢下线）：
                               先保留草稿，再回登录页，登录成功会自动回到本页继续发布 */
                            this.resumeDraft();
                            this.authBlocked = true;
                            this.toLogin("登录已失效，请重新登录！", this.$route.fullPath);
                        } else {
                            // 发布失败：恢复草稿，避免内容丢失
                            this.resumeDraft();
                            this.$message({
                                message: "发布失败" + res.data.message,
                                type: "warning"
                            });
                        }
                    })
                    .catch(err => {
                        publishLoading.close();
                        this.submitting = false;
                        // 网络异常：恢复草稿，避免内容丢失
                        this.resumeDraft();
                    });
            });
        },
        // 缩略图 课程卡图片
        uploadImageUrlthumb(file) {},

        // 复制手机端链接：优先用剪贴板 API，http / 老浏览器回退到 execCommand
        copyMobileLink() {
            let text = this.mobileLink;
            let ok = () => this.$message.success("链接已复制");
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                    .writeText(text)
                    .then(ok)
                    .catch(() => this.fallbackCopy(text, ok));
                return;
            }
            this.fallbackCopy(text, ok);
        },
        fallbackCopy(text, ok) {
            let input = document.createElement("textarea");
            input.value = text;
            // 移出可视区域，避免页面滚动
            input.style.position = "fixed";
            input.style.top = "-9999px";
            document.body.appendChild(input);
            input.select();
            let done = false;
            try {
                done = document.execCommand("copy");
            } catch (e) {
                done = false;
            }
            document.body.removeChild(input);
            done ? ok() : this.$message.warning("复制失败，请手动选中链接复制");
        },
        // 发布成功弹框关闭后回到首页
        afterPublishSuccess() {
            this.$router.push("/");
        },

        /* ---------------- 图片 / 视频（可同时上传） ---------------- */
        // 该处已上传的视频
        /* 视频列表的字段名：模块名 jc_list / zd_list 对应 form 里声明的 jc_videoList / zd_videoList。
           不能直接拼 name + "_videoList"（会得到不存在的 jc_list_videoList，导致首次上传报错） */
        videoListName(name) {
            return String(name).replace(/_list$/, "") + "_videoList";
        },
        videoOf(name) {
            // 兼容历史逻辑（保留）：返回第一个视频；多视频场景下请用 videosOf
            return (this.form[this.videoListName(name)] || [])[0] || null;
        },
        // 取该模块下所有视频（用于预览 / 多视频拼接等）
        videosOf(name) {
            return this.form[this.videoListName(name)] || [];
        },
        // 该处视频的地址（提交 vid / lstVid 用）：movieUpload 返回的是完整 OSS 地址
        // 多个视频以英文逗号 "," 隔开，与多张图片（lstPic）保持一致
        vidOf(name) {
            let videos = this.videosOf(name);
            if (!videos.length) return "";
            return videos
                .map(video => {
                    if (!video) return "";
                    let url = video.videoUrl || video.imgGid || "";
                    if (!url) return "";
                    // 兼容历史草稿里存的 gid
                    return /^https?:\/\//i.test(url) ? url : this.picStr + url;
                })
                .filter(Boolean)
                .join(",");
        },
        hasVideo(name) {
            return !!(this.form[this.videoListName(name)] || []).length;
        },
        // 上传中：自定义进度卡替代 Element 的空白缩略图；按 uid 支持多视频同时上传
        // 上传按钮始终可见，达到 MAX_VIDEO 时通过 hide-add 隐藏
        hideVideoAdd(name) {
            return (this.form[this.videoListName(name)] || []).length >= this.MAX_VIDEO;
        },
        // 当前模块是否有视频正在上传中（用于 Element 的 is-video-uploading 状态）
        hasVideoUploading(name) {
            return !!this.videoUploads[name] && Object.keys(this.videoUploads[name] || {}).length > 0;
        },
        // 当前模块上传中的视频进度列表（数组，模板里 v-for）
        videoUploadingList(name) {
            let bucket = this.videoUploads[name] || {};
            return Object.keys(bucket).map(uid => ({ uid, ...bucket[uid] }));
        },
        imageTip(name) {
            let count = (this.form[name] || []).length;
            return count ? "已上传 " + count + " 张图片，最多 " + this.MAX_IMAGE + " 张" : "可上传多张图片（最多 " + this.MAX_IMAGE + " 张）";
        },
        videoTip(name) {
            let count = (this.form[this.videoListName(name)] || []).length;
            let size = Math.floor(this.MAX_VIDEO_SIZE / 1024 / 1024);
            if (count) {
                return "已上传 " + count + " 个视频，最多 " + this.MAX_VIDEO + " 个（单个不超过 " + size + "M）";
            }
            return "可上传多个视频（最多 " + this.MAX_VIDEO + " 个，单个不超过 " + size + "M）";
        },
        // 图片或视频至少上传一个（图片必填项的校验规则）
        validateMedia(rule, value, callback, name) {
            let images = Array.isArray(value) ? value : [];
            if (images.length || this.hasVideo(name)) return callback();
            callback(new Error(rule.message || "请上传影像资料或视频"));
        },
        // 上传/删除后刷新该项校验状态（仅校验配置了规则的项）
        revalidate(name) {
            if (!this.$refs.form || !this.rules[name]) return;
            this.$refs.form.validateField(name);
        },
        /* ---------------- 上传前校验 & 预览 ---------------- */
        // 图片：类型 / 大小，返回 false 直接阻止上传（不会留下失败项）
        checkImage(file, name) {
            if (file.type.indexOf("image/") !== 0) {
                this.$message.warning("只能上传图片文件");
                return false;
            }
            if (file.size > this.MAX_IMAGE_SIZE) {
                this.$message.warning("单张图片不能超过 " + Math.floor(this.MAX_IMAGE_SIZE / 1024 / 1024) + "MB");
                return false;
            }
            return true;
        },
        // 视频：类型 / 大小 / 数量限制（每个模块最多 MAX_VIDEO 个视频）
        checkVideo(file, name) {
            // 同一上传框内已有视频数 + 本次"同 uid"的请求数量：用于阻断"勾选多个文件"时一次性超过上限
            let listName = this.videoListName(name),
                exists = (this.form[listName] || []).length;
            if (exists >= this.MAX_VIDEO) {
                this.$message.warning("每个模块最多上传 " + this.MAX_VIDEO + " 个视频");
                return false;
            }
            if (file.type.indexOf("video/") !== 0) {
                this.$message.warning("只能上传视频文件");
                return false;
            }
            if (file.size > this.MAX_VIDEO_SIZE) {
                this.$message.warning("视频不能超过 " + Math.floor(this.MAX_VIDEO_SIZE / 1024 / 1024) + "MB");
                return false;
            }
            return true;
        },
        // 超出图片数量
        onImageExceed() {
            this.$message.warning("每个模块最多上传 " + this.MAX_IMAGE + " 张图片");
        },
        // 大图预览：本地已选图片用本地地址，已上传的用服务端地址
        previewImage(file, name) {
            let gid = (file && file.imgGid) || "";
            this.previewImageUrl = (file && file.url) || (gid ? this.picStr + gid : "");
            if (!this.previewImageUrl) return;
            this.previewImageVisible = true;
        },
        // 视频播放预览：movieUpload 返回完整 OSS 地址，直接播放
        // 多视频场景：用 el-upload 回调里被点击的 file 精确定位到对应视频，避免播放拼接串
        previewVideo(file, name) {
            let url = "";
            if (file && (file.videoUrl || file.imgGid)) {
                url = file.videoUrl || file.imgGid || "";
                // 兼容历史草稿里存的 gid
                if (!/^https?:\/\//i.test(url)) url = this.picStr + url;
            }
            if (!url) url = this.vidOf(name);
            if (!url) {
                this.$message.warning("视频正在处理中，暂无法预览");
                return;
            }
            this.previewVideoUrl = url;
            this.previewVideoVisible = true;
        },
        // 校验失败时滚动到第一个错误项，避免用户不知道哪里没填
        scrollToFirstError(invalidFields) {
            let props = Object.keys(invalidFields || {});
            if (!props.length) return;
            let field = (this.$refs.form.fields || []).find(item => item.prop === props[0]);
            if (field && field.$el && field.$el.scrollIntoView) {
                field.$el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
        // 上传被拒绝/失败后，清掉组件内部残留的失败项
        clearFailItem(listName) {
            this.form[listName] = (this.form[listName] || []).slice();
        },
        // 删除图片
        handleRemove(file, name) {
            let list = this.form[name] || [],
                idx = list.findIndex(item => item && item.uid === file.uid);
            if (idx == -1) idx = list.indexOf(file);
            if (idx > -1) list.splice(idx, 1);

            let files = this.form[name + "_File"] || [],
                fi = files.indexOf(file);
            if (fi > -1) files.splice(fi, 1);

            this.revalidate(name);
        },
        // 删除视频
        handleRemoveVideo(file, name) {
            let listName = this.videoListName(name),
                list = this.form[listName] || [],
                idx = list.findIndex(item => item && item.uid === file.uid);
            if (idx == -1) idx = list.indexOf(file);
            if (idx > -1) list.splice(idx, 1);

            this.revalidate(name);
        },
        /*
         * 图片上传：必须回调 onSuccess / onError，否则组件会一直停留在"上传中"状态
         * 上传成功后往 file-list 写入 Element 要求的文件对象（含 uid，不能只存 imgGid 字符串）
         */
        beforeAvatarUpload(param, index) {
            // 图片框只接收图片
            if (param.file.type && param.file.type.indexOf("image/") !== 0) {
                param.onError(new Error("fileType"));
                this.clearFailItem(index);
                this.$message.warning("图片上传仅支持图片格式，如需上传视频请使用视频上传框！");
                return;
            }

            /* 智能压缩：对齐 bonetoday_wechat_sub。
               透明 / 动图会被 smartCompress 跳过，原图直传；
               <500KB 也会被跳过，避免几 KB 的图被压成更大的 JPEG */
            smartCompress(param.file).then(result => {
                const fileToUpload = result.file
                const picType = (fileToUpload.type || 'image/jpeg').replace(/^image\//, '') || 'jpg'
                if (!result.skipped && result.beforeKB !== result.afterKB) {
                    console.log(
                        '[图片压缩] ' + (param.file.name || '') + ' ' +
                        result.beforeKB + 'KB -> ' + result.afterKB + 'KB'
                    )
                }

                let fd = new FormData();
                fd.append("imgData", fileToUpload);
                /* picType 与 bonetoday_wechat_sub 一致：后端按 picType 决定后缀 / CDN 缓存策略 */
                fd.append("picType", picType);

                this.$axios
                    .post("/SD/common/picUpload", fd)
                    .then(res => {
                        let data = res.data;
                        if (data.code == "1") {
                            this.form[index].push({
                                name: param.file.name,
                                uid: param.file.uid,
                                status: "success",
                                imgGid: data.imgGid,
                                url: this.getLocalUrl(param.file)
                            });
                            this.form[index + "_File"].push(fileToUpload);
                            // 通知组件上传完成，避免一直显示上传中
                            param.onSuccess(data);
                            this.revalidate(index);
                            this.$message({
                                message: data.message,
                                type: "success"
                            });
                        } else {
                            param.onError(data);
                            this.clearFailItem(index);
                            this.$message.error(data.message || "上传失败！");
                        }
                    })
                    .catch(() => {
                        param.onError(new Error("上传失败"));
                        this.clearFailItem(index);
                        this.$message.error("上传失败，请重试！");
                    });
            }).catch(() => {
                /* 智能压缩抛异常时回退原图上传 */
                let fd = new FormData();
                fd.append("imgData", param.file);
                fd.append("picType", (param.file.type || 'image/jpeg').replace(/^image\//, '') || 'jpg');
                this.$axios
                    .post("/SD/common/picUpload", fd)
                    .then(res => {
                        let data = res.data;
                        if (data.code == "1") {
                            this.form[index].push({
                                name: param.file.name,
                                uid: param.file.uid,
                                status: "success",
                                imgGid: data.imgGid,
                                url: this.getLocalUrl(param.file)
                            });
                            this.form[index + "_File"].push(param.file);
                            param.onSuccess(data);
                            this.revalidate(index);
                            this.$message({ message: data.message, type: "success" });
                        } else {
                            param.onError(data);
                            this.clearFailItem(index);
                            this.$message.error(data.message || "上传失败！");
                        }
                    })
                    .catch(() => {
                        param.onError(new Error("上传失败"));
                        this.clearFailItem(index);
                        this.$message.error("上传失败，请重试！");
                    });
            });
        },
        /*
         * 视频上传：每个模块 1 个，缩略图截取视频第一帧
         * 接口与 H5 端保持一致：POST /SD/common/movieUpload，表单字段 multipartFile，
         * 成功（code == 1）时 result_data 为视频的 OSS 地址，提交时 vid / lstVid 直接传该地址
         */
        beforeVideoUpload(param, index) {
            let listName = this.videoListName(index),
                file = param.file,
                uid = file.uid;

            // 数量上限：包含本文件（避免同时勾选多个时逐个失败体验差）
            if ((this.form[listName] || []).length >= this.MAX_VIDEO) {
                param.onError(new Error("limit"));
                this.clearFailItem(listName);
                return this.$message.warning("每个模块最多上传 " + this.MAX_VIDEO + " 个视频");
            }
            // 同一个文件正在上传中（el-upload 会自动给每个文件生成唯一 uid）
            if (this.videoUploads[index] && this.videoUploads[index][uid]) {
                param.onError(new Error("uploading"));
                this.clearFailItem(listName);
                return this.$message.warning("该视频正在上传中，请稍候");
            }

            // 立刻占位：Element 默认会在上传中显示一块取不到画面的空白缩略图 + 超框的圆形进度
            // videoUploads 用两层结构 { [name]: { [uid]: { percent, thumb } } }，支持同一视频框内多视频并行
            // 【关键】不能往 form[listName] push 占位对象：el-upload 内部 uploadFiles 同步时会
            // 渲染这个 0 尺寸的 uploading 卡片，引发 picture-card 布局重排把已上传视频挤掉。
            // 整个上传中状态完全交给外层 .video-uploading 自己渲染（见 template 第 110-125 行）
            if (!this.videoUploads[index]) this.$set(this.videoUploads, index, {});
            /* 占位对象同时缓存 file、loaded、total、status、startedAt、abort：
               - file 用于"重试"按钮直接调 uploadVideoFile(file, index)
               - status 区分 'uploading' / 'failed' / 'success' / 'canceled'
               - loaded/total/eta 展示"已传 X / 总 Y" + 剩余时间 */
            this.$set(this.videoUploads[index], uid, {
                percent: 0,
                thumb: "",
                status: "uploading",
                file: file,
                loaded: 0,
                total: file.size || 0,
                eta: "",
                startedAt: Date.now(),
                abort: null
            });

            /* 调用 uploadVideoFile 完成实际上传（重试和首次上传走同一份逻辑） */
            this.uploadVideoFile(file, index);
            /* 通知 Element 上传已开始，让 onRemove 等回调能正常联动 */
            param.onSuccess && param.onSuccess({ code: "0", message: "uploading" });
        },
        /* 视频封面上传到 picUpload（与图片共用一个后端通道），返回 https 地址
           - 截帧得到的是 Blob，先走 smartCompress 同样做一次压缩
           - 接口路径 /SD/common/picUpload，对齐 bonetoday_wechat_sub */
        uploadCoverToOss(blob, videoName) {
            if (!blob) return Promise.resolve("");
            const file = coverToFile(blob);
            return smartCompress(file).then(result => {
                const coverFile = result.file;
                const fd = new FormData();
                fd.append("imgData", coverFile);
                fd.append("picType", (coverFile.type || "image/jpeg").replace(/^image\//, "") || "jpg");
                return this.$axios
                    .post("/SD/common/picUpload", fd, { timeout: 60 * 1000 })
                    .then(res => {
                        const data = res && res.data;
                        if (String(data && data.code) === "1" && data.imgGid) {
                            /* picUpload 返回的是 gid / path，需要拼成 https 公开地址才能在 img 标签里直接展示 */
                            const url = /^https?:\/\//i.test(data.imgGid) ? data.imgGid : (this.picStr + data.imgGid);
                            return this.toHttps(url);
                        }
                        console.warn("[视频封面上传] 返回异常：", data);
                        return "";
                    })
                    .catch(err => {
                        console.warn("[视频封面上传] 失败：", err);
                        return "";
                    });
            });
        },
        // 首帧截取失败（超时 / 编码不支持）时的兜底缩略图，避免缩略图区域一片空白
        videoPlaceholder() {
            let svg =
                '<svg xmlns="http://www.w3.org/2000/svg" width="220" height="220">' +
                '<rect width="220" height="220" fill="#eef1f6"/>' +
                '<path d="M84 72 L150 110 L84 148 Z" fill="#a8b2c4"/></svg>';
            return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
        },
        /* 体积格式化：< 1MB 用 KB，否则用 MB（带 2 位小数） */
        formatSize(bytes) {
            if (!bytes || bytes <= 0) return "0 B"
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + " KB"
            if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(2) + " MB"
            return (bytes / 1024 / 1024 / 1024).toFixed(2) + " GB"
        },
        /* 剩余时间格式化（秒 → "1 分 23 秒" / "23 秒" / "2 时 5 分"） */
        formatEta(seconds) {
            if (!seconds || seconds <= 0 || !isFinite(seconds)) return ""
            seconds = Math.round(seconds)
            if (seconds < 60) return seconds + " 秒"
            if (seconds < 3600) {
                const m = Math.floor(seconds / 60)
                const s = seconds % 60
                return m + " 分" + (s > 0 ? " " + s + " 秒" : "")
            }
            const h = Math.floor(seconds / 3600)
            const m = Math.floor((seconds % 3600) / 60)
            return h + " 时" + (m > 0 ? " " + m + " 分" : "")
        },
        /* 把上传失败/上传中的占位移除。done() 也会调这个 */
        removeUploading(index, uid) {
            if (this.videoUploads[index] && this.videoUploads[index][uid]) this.$delete(this.videoUploads[index], uid)
            if (this.videoUploads[index] && !Object.keys(this.videoUploads[index]).length) this.$delete(this.videoUploads, index)
        },
        /* "重试"按钮：直接用缓存的 file 重新调上传逻辑，状态从 'failed' 切回 'uploading' */
        retryVideoUpload(up, index) {
            const file = up && up.file
            if (!file) {
                this.$message.warning("文件已失效，请重新选择")
                this.removeUploading(index, up.uid)
                return
            }
            this.$set(this.videoUploads[index], up.uid, {
                percent: 0,
                thumb: up.thumb || "",
                status: "uploading",
                file: file,
                loaded: 0,
                total: file.size || 0,
                eta: "",
                startedAt: Date.now()
            })
            this.uploadVideoFile(file, index)
        },
        /* "取消"按钮：把占位移除（OSS 直传走的是 axios 不能直接 abort，但要清理 UI 防泄漏） */
        cancelVideoUpload(up, index) {
            this.removeUploading(index, up.uid)
            this.$message.info("已取消上传")
        },
        /* "移除"按钮（失败状态下）：彻底删除这条失败的占位 */
        dismissVideoUpload(up, index) {
            this.removeUploading(index, up.uid)
        },
        /* 提取出来的上传逻辑：beforeVideoUpload 入口 和 retryVideoUpload 复用同一份 */
        uploadVideoFile(file, index) {
            const listName = this.videoListName(index)
            const uid = file.uid
            const uploadStartAt = Date.now()
            const done = () => this.removeUploading(index, uid)

            const thumbPromise = captureVideoCover(file)
                .then(blob => this.uploadCoverToOss(blob, file.name))
                .catch(() => this.captureFirstFrame(file))
                .then(thumb => {
                    if (this.videoUploads[index] && this.videoUploads[index][uid]) {
                        this.$set(this.videoUploads[index][uid], "thumb", thumb || this.videoPlaceholder())
                    }
                    return thumb
                })

            /* 同时异步读一下视频时长，存到 videoDurationCache 备用 */
            this.readVideoDuration(file).then(duration => {
                this.$set(this.videoDurationCache, uid, duration)
            })

            const videoPromise = ossUploader(
                file,
                "app-movie/",
                "movie",
                Math.floor(this.MAX_VIDEO_SIZE / 1024 / 1024),
                info => {
                    const percent = info && typeof info === 'object' ? info.percent : info
                    const loaded = info && typeof info === 'object' ? info.loaded : 0
                    const total = info && typeof info === 'object' ? info.total : file.size || 0
                    if (this.videoUploads[index] && this.videoUploads[index][uid]) {
                        const up = this.videoUploads[index][uid]
                        this.$set(this.videoUploads[index][uid], "percent", percent)
                        this.$set(this.videoUploads[index][uid], "loaded", loaded)
                        this.$set(this.videoUploads[index][uid], "total", total || up.total)
                        if (percent > 5 && total > 0) {
                            const elapsed = (Date.now() - uploadStartAt) / 1000
                            if (elapsed > 1) {
                                const speed = loaded / elapsed
                                const remain = (total - loaded) / speed
                                this.$set(this.videoUploads[index][uid], "eta", this.formatEta(remain))
                            }
                        }
                    }
                }
            )

            Promise.all([thumbPromise, videoPromise])
                .then(([thumb, videoResult]) => {
                    const url = videoResult && videoResult.url
                    if (!url) throw new Error(videoResult && videoResult.error ? videoResult.error : "视频上传失败")
                    if (!Array.isArray(this.form[listName])) this.$set(this.form, listName, [])
                    this.form[listName].push({
                        name: file.name,
                        uid: file.uid,
                        status: "success",
                        isVideo: true,
                        videoUrl: url,
                        coverUrl: thumb && /^https?:\/\//i.test(thumb) ? thumb : "",
                        imgGid: url,
                        url: thumb || this.videoPlaceholder(),
                        size: file.size,
                        duration: this.videoDurationCache[uid] || 0
                    })
                    this.form[listName] = this.form[listName].slice()
                    done()
                })
                .catch(e => {
                    /* 失败时把 status 改成 'failed'，保留 file 给重试用 */
                    if (this.videoUploads[index] && this.videoUploads[index][uid]) {
                        this.$set(this.videoUploads[index][uid], "status", "failed")
                        this.$set(this.videoUploads[index][uid], "percent", 0)
                    }
                    this.$message.error("视频上传失败：" + (e && e.message ? e.message : this.formatUploadError(e)))
                })
        },
        /* 读视频时长（异步非阻塞，失败也不影响上传） */
        readVideoDuration(file) {
            return new Promise(resolve => {
                if (!file || typeof document === 'undefined') return resolve(0)
                const url = URL.createObjectURL(file)
                const v = document.createElement('video')
                v.preload = 'metadata'
                v.muted = true
                v.src = url
                const cleanup = () => {
                    try { URL.revokeObjectURL(url) } catch (e) {}
                }
                v.addEventListener('loadedmetadata', () => {
                    const d = isFinite(v.duration) ? v.duration : 0
                    cleanup()
                    resolve(d)
                })
                v.addEventListener('error', () => {
                    cleanup()
                    resolve(0)
                })
                /* 6 秒拿不到时长（很多手机视频元数据超大）就放弃 */
                setTimeout(() => { cleanup(); resolve(0) }, 6000)
            })
        },
        /* 把秒数格式化为 "1:23" 或 "1:02:34" */
        formatDuration(seconds) {
            if (!seconds || !isFinite(seconds) || seconds <= 0) return ""
            seconds = Math.round(seconds)
            const h = Math.floor(seconds / 3600)
            const m = Math.floor((seconds % 3600) / 60)
            const s = seconds % 60
            const pad = n => (n < 10 ? "0" + n : "" + n)
            return h > 0 ? (h + ":" + pad(m) + ":" + pad(s)) : (m + ":" + pad(s))
        },
        // 统一转成 https，避免 https 页面下播放 http 视频被浏览器拦截
        toHttps(url) {
            return String(url || "").replace(/^http:\/\//i, "https://");
        },
        // 上传失败原因：413 / 服务器返回的 message / 超时等
        formatUploadError(e) {
            let res = e && e.response,
                data = res && res.data;
            if (typeof data === "string" && data.indexOf("<Code>") > -1) {
                let code = (data.match(/<Code>([\s\S]*?)<\/Code>/) || [])[1];
                let message = (data.match(/<Message>([\s\S]*?)<\/Message>/) || [])[1];
                return [code, message].filter(Boolean).join(" ");
            }
            if (res && res.status === 413) return "文件超过服务器限制（413）";
            /* 网关超时：服务器处理视频超过 60 秒被 nginx 掐断（实测 >2~3MB 就会触发），
               提示用户压缩视频，同时给出服务端需要调整配置的说明 */
            if (res && (res.status === 504 || res.status === 502 || res.status === 503))
                return "服务器处理超时，请压缩视频大小后重试（服务端网关 60 秒超时，需运维调大 proxy_read_timeout）";
            if (data && typeof data === "object" && data.message) return data.message;
            if (e && /timeout/i.test(e.message || "")) return "上传超时，请重试";
            return (res && res.status ? "HTTP" + res.status + " " : "") + ((e && e.message) || "请重试");
        },
        // 截取视频第一帧，返回 dataURL（取不到时返回空串，不阻塞视频上传）
        captureFirstFrame(file) {
            return new Promise(resolve => {
                let objectUrl = "";
                try {
                    objectUrl = window.URL.createObjectURL(file);
                } catch (e) {
                    return resolve("");
                }

                let video = document.createElement("video"),
                    finished = false,
                    timer = null,
                    finish = dataUrl => {
                        if (finished) return;
                        finished = true;
                        clearTimeout(timer);
                        try {
                            window.URL.revokeObjectURL(objectUrl);
                        } catch (e) {}
                        video.removeAttribute("src");
                        resolve(dataUrl || "");
                    },
                    draw = () => {
                        try {
                            let canvas = document.createElement("canvas");
                            canvas.width = video.videoWidth || 320;
                            canvas.height = video.videoHeight || 180;
                            canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
                            finish(canvas.toDataURL("image/jpeg", 0.8));
                        } catch (e) {
                            finish("");
                        }
                    };

                // 兜底：3 秒内没取到帧就放弃缩略图
                timer = setTimeout(() => {
                    video.readyState >= 2 ? draw() : finish("");
                }, 3000);

                video.muted = true;
                video.playsInline = true;
                video.preload = "auto";
                video.onerror = () => finish("");
                // 加载到首帧后轻微 seek，确保能稳定绘制第一帧
                video.onloadeddata = () => {
                    video.readyState >= 2 ? (video.currentTime = 0.001) : draw();
                };
                video.onseeked = draw;
                video.src = objectUrl;
            });
        },
        // 本地预览地址，图片使用
        getLocalUrl(file) {
            try {
                return window.URL.createObjectURL(file);
            } catch (e) {
                return "";
            }
        }
    }
};
</script>

<style scoped>
#content {
    padding: 40px 0;
}
#BoneAdd {
    background-color: #fafafa;
    margin: 70px 70px 0;
    padding-top: 40px;
    padding-bottom: 40px;
}

.el-radio /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #5680FA !important;
}
.el-radio /deep/ .el-radio__input.is-checked .el-radio__inner {
    background: #5680FA !important;
    border-color: #5680FA !important;
}
.el-radio /deep/ .el-radio__input.is-checked .el-radio__inner:hover{
    border-color: #5680FA !important;
}
.el-upload /deep/ .el-upload--picture-card:hover, .el-upload:focus{
    border-color: #5680FA;
    color: #5680FA;
}

.title {
    height: 50px;
    line-height: 50px;
    margin-left: 0;
    border-bottom: #d9d9d9 1px solid;
    margin-bottom: 15px;
    width: auto;
}

.sui {
    text-align: center;
}

.el-form {
    background-color: #fff;
    border: #d9d9d9 1px solid;
    padding: 0 20px;
}

/* 图片 */
.avatar {
    width: 120px;
    height: 120px;
    display: block;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

/* 达到数量限制时只隐藏新增按钮，已上传的缩略图照常显示 */
.hide-add /deep/ .el-upload--picture-card {
    display: none;
}

/* 视频上传：缩略图为视频第一帧，居中加播放按钮以便与图片区分 */
.video-upload /deep/ .el-upload-list--picture-card .el-upload-list__item::after {
    content: "▶";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    padding-left: 3px;
    line-height: 30px;
    text-align: center;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.45);
    color: #fff;
    font-size: 12px;
    pointer-events: none;
}
/*
 * 上传中的那一项交给自定义占位卡展示：
 * Element 默认在 picture-card 下不渲染缩略图，圆形进度固定 126px 会超出 110px 的盒子
 */
.video-upload.is-video-uploading /deep/ .el-upload-list__item,
#BoneAdd .video-upload /deep/ .el-upload-list__item.is-uploading {
    display: none;
}
/* 圆形进度默认宽 126px，会超出 110px 的盒子，这里统一收小（内联样式需要 !important） */
#BoneAdd /deep/ .el-upload-list--picture-card .el-progress,
#BoneAdd /deep/ .el-upload-list--picture-card .el-progress .el-progress-circle {
    width: 86px !important;
    height: 86px !important;
}
#BoneAdd /deep/ .el-upload-list--picture-card .el-progress__text {
    font-size: 14px !important;
    min-width: 30px;
}
/* 视频上传中的占位卡 */
#BoneAdd .video-uploading {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 110px;
    height: 110px;
    overflow: hidden;
    border: 1px solid #e8ebf1;
    border-radius: 10px;
    background-color: #f5f7fb;
}
#BoneAdd .video-uploading-thumb {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    color: #c0c8d8;
    font-size: 26px;
}
#BoneAdd .video-uploading-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    color: #fff;
}
#BoneAdd .video-uploading-percent {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
}
#BoneAdd .video-uploading-text {
    margin-top: 2px;
    font-size: 11px;
    opacity: 0.85;
}
#BoneAdd .video-uploading-bar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background-color: rgba(255, 255, 255, 0.3);
}
#BoneAdd .video-uploading-bar > i {
    display: block;
    height: 100%;
    width: 0;
    background-color: #5680fa;
    transition: width 0.2s linear;
}

/* 已上传视频卡片：自己渲染（避开 el-upload 内部 uploadFiles 状态机，避免上传中把已渲染的挤掉）
   尺寸对齐 picture-card 的 110x110 盒子，hover 时显示预览/删除按钮 */
#BoneAdd .video-card {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 110px;
    height: 110px;
    margin: 0 8px 8px 0;
    overflow: hidden;
    border: 1px solid #e8ebf1;
    border-radius: 10px;
    background-color: #f5f7fb;
    cursor: pointer;
}
#BoneAdd .video-card-thumb {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-color: #1f1f1f;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
}
#BoneAdd .video-card-play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 36px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    opacity: 0.92;
    /* 仅用 drop-shadow 描边让图标在浅色/深色封面上都清晰，无任何形状背景 */
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.6))
            drop-shadow(0 0 6px rgba(0, 0, 0, 0.35));
    transition: opacity 0.2s ease, transform 0.2s ease;
}
#BoneAdd .video-card-play svg {
    display: block;
}
#BoneAdd .video-card:hover .video-card-play {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
}
#BoneAdd .video-card-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    padding: 4px 0;
    background-color: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.15s linear;
}
#BoneAdd .video-card:hover .video-card-actions {
    opacity: 1;
}
#BoneAdd .video-card-action {
    cursor: pointer;
    padding: 2px 6px;
}
#BoneAdd .video-card-action:hover {
    color: #5680fa;
}
/* 视频左下角时长徽章 / 右下角大小徽章（半透明黑底） */
#BoneAdd .video-card-duration,
#BoneAdd .video-card-size {
    position: absolute;
    bottom: 4px;
    padding: 1px 5px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 11px;
    line-height: 14px;
    pointer-events: none;
}
#BoneAdd .video-card-duration {
    left: 4px;
}
#BoneAdd .video-card-size {
    right: 4px;
}
/* 封面图片加载中：浅灰渐变闪烁（避免白底闪一下） */
#BoneAdd .video-card-thumb.is-loading {
    background-size: 100% 100% !important;
    background: linear-gradient(90deg, #eef1f6 0%, #f5f7fb 50%, #eef1f6 100%);
    background-size: 200% 100% !important;
    animation: video-card-skeleton 1.4s ease-in-out infinite;
}
@keyframes video-card-skeleton {
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
}
/* 上传中详细进度：已传 / 总 + 剩余时间 */
#BoneAdd .video-uploading-detail {
    display: block;
    margin-top: 2px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
}
#BoneAdd .video-uploading-eta {
    opacity: 0.85;
}
/* 失败图标 */
#BoneAdd .video-uploading-fail-icon {
    font-size: 28px;
    color: #ff4949;
    margin-bottom: 2px;
}
/* 上传中/失败的操作条（取消/重试/移除） */
#BoneAdd .video-uploading-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    padding: 4px 0;
    background-color: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.15s linear;
}
#BoneAdd .video-uploading:hover .video-uploading-actions {
    opacity: 1;
}
/* 失败状态操作条始终显示（用户需要立刻看到"重试"） */
#BoneAdd .video-uploading.is-failed .video-uploading-actions {
    opacity: 1;
}
#BoneAdd .video-uploading-action {
    cursor: pointer;
    padding: 2px 6px;
}
#BoneAdd .video-uploading-action:hover {
    color: #5680fa;
}
#BoneAdd .video-uploading.is-failed .video-uploading-thumb {
    opacity: 0.55;
}

/* 图片 / 视频预览弹窗 */
.media-preview {
    text-align: center;
    min-height: 200px;
}
.media-preview img {
    max-width: 100%;
    max-height: 60vh;
}
.media-preview video {
    width: 100%;
    max-height: 60vh;
    background-color: #000;
}
.media-preview-empty {
    color: #909399;
    font-size: 13px;
    line-height: 200px;
}

/* 病例思考：标题 + 参考模板按钮 */
.label-with-btn {
    display: inline-flex;
    align-items: center;
    height: 40px;
    vertical-align: middle;
    white-space: nowrap;
}
/* 参考模板按钮：实心高亮 + 描边，视觉上比其它元素更跳，吸引用户点击 */
.template-btn {
    margin-left: 10px;
    padding: 5px 12px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 500;
    background-color: #2f6bff !important;
    border-color: #2f6bff !important;
    color: #fff !important;
    box-shadow: 0 2px 6px 0 rgba(47, 107, 255, 0.35);
    transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.template-btn /deep/ span {
    font-weight: 500;
}

.template-btn:hover {
    background-color: #4d80ff !important;
    border-color: #4d80ff !important;
    color: #fff !important;
    box-shadow: 0 3px 10px 0 rgba(47, 107, 255, 0.45);
    transform: translateY(-1px);
}

.template-btn:active {
    background-color: #2459db !important;
    border-color: #2459db !important;
    transform: translateY(0);
}
/* 模板回填提示 */
.template-tip {
    margin-top: 8px;
    padding: 6px 12px;
    background-color: #ecf3ff;
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
    color: #5680fa;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.template-tip-text b {
    color: #f56c6c;
}
.template-tip-btn {
    margin-left: 12px;
    flex-shrink: 0;
    color: #f56c6c;
    cursor: pointer;
}
.template-tip-btn:hover {
    text-decoration: underline;
}
/* 自动暂存提示（左边距与 label-width 保持一致） */
.draft-tip {
    margin: 0 0 10px 180px;
    font-size: 12px;
    color: #909399;
}
/* 参考模板弹窗 */
.scene-list {
    max-height: 420px;
    overflow-y: auto;
}
.scene-item {
    display: flex;
    align-items: center;
    padding: 14px 12px;
    margin-bottom: 10px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}
.scene-item:hover {
    border-color: #5680fa;
    background-color: #f5f8ff;
}
.scene-icon-wrap {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    background-color: #5680fa;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.scene-name {
    flex: 1;
    margin-left: 12px;
    font-size: 15px;
    color: #303133;
}
.scene-arrow {
    color: #c0c4cc;
}

/* ==================== 整体视觉优化 ==================== */
#BoneAdd {
    margin: 70px auto 40px;
    padding: 30px 0 40px;
    max-width: 1100px;
    background-color: transparent;
}

/* 表单卡片 */
#BoneAdd .el-form {
    box-sizing: border-box;
    margin: 0 auto;
    padding: 12px 32px 28px;
    border: none;
    border-radius: 12px;
    background-color: #fff;
    box-shadow: 0 2px 14px 0 rgba(20, 35, 70, 0.08);
}

/* 分组标题：负外边距让标题文字与表单标签同一起始线，蓝色竖条落在卡片留白里 */
#BoneAdd .title {
    position: relative;
    height: auto;
    margin: 30px 0 18px -12px;
    padding-left: 12px;
    border-bottom: none;
    line-height: 24px;
    font-size: 17px;
    font-weight: 600;
    color: #1f2733;
}

#BoneAdd .title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 3px;
    bottom: 3px;
    width: 3px;
    border-radius: 2px;
    background-color: #5680fa;
}

#BoneAdd .el-form > .title:first-of-type {
    margin-top: 10px;
}

/* 表单项 */
#BoneAdd .el-form-item {
    margin-bottom: 22px;
}

/* 标签统一左对齐：所有字段的左侧文字落在同一条竖线上 */
#BoneAdd /deep/ .el-form-item__label {
    padding-right: 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    color: #414c60;
}

#BoneAdd /deep/ .el-form-item.is-required .el-form-item__label {
    color: #414c60;
}

/* 必填星号统一贴在标签左侧，保证星号也对齐 */
#BoneAdd /deep/ .el-form-item.is-required .el-form-item__label::before {
    content: "*";
    margin-right: 4px;
    color: #f56c6c;
}

/* 下拉框默认是内容宽度，与输入框右边缘不齐，这里拉成同宽 */
#BoneAdd /deep/ .el-select {
    width: 100%;
}

/* 输入框 / 文本域 */
#BoneAdd /deep/ .el-input__inner,
#BoneAdd /deep/ .el-textarea__inner {
    border: 1px solid #e2e6ee;
    border-radius: 8px;
    color: #333c4d;
    transition: border-color 0.2s, box-shadow 0.2s;
}

#BoneAdd /deep/ .el-input__inner:hover,
#BoneAdd /deep/ .el-textarea__inner:hover {
    border-color: #c6d2ea;
}

#BoneAdd /deep/ .el-input__inner:focus,
#BoneAdd /deep/ .el-textarea__inner:focus,
#BoneAdd /deep/ .el-select .el-input__inner:focus {
    border-color: #5680fa;
    box-shadow: 0 0 0 3px rgba(86, 128, 250, 0.12);
}

#BoneAdd /deep/ .el-textarea__inner {
    padding: 10px 14px;
    line-height: 1.8;
}

#BoneAdd /deep/ .el-textarea .el-input__count {
    right: 12px;
    bottom: 2px;
    background-color: transparent;
    color: #b3bccd;
    font-size: 12px;
}

#BoneAdd /deep/ .el-input__inner::placeholder,
#BoneAdd /deep/ .el-textarea__inner::placeholder {
    color: #b6bfd0;
}

/* 年龄：输入框 + 单位同行垂直居中；el-col 默认 span=2 太窄（约 74px） */
#BoneAdd .age-item /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
}

#BoneAdd .age-item .el-col {
    float: none;
}

#BoneAdd .age-item .el-col:first-child {
    width: 160px;
}

#BoneAdd .age-item .sui {
    width: auto;
    margin-left: 10px;
    line-height: 40px;
    text-align: left;
    font-size: 14px;
    color: #8a94a6;
}

/* 去掉 number 输入框右侧的上下箭头 */
#BoneAdd /deep/ input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
}

#BoneAdd /deep/ input[type="number"]::-webkit-outer-spin-button,
#BoneAdd /deep/ input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

#BoneAdd /deep/ .el-radio__label {
    font-size: 14px;
    color: #5c6678;
}

/* 四个「文本 + 影像资料」模块卡片
   负外边距让卡片通栏，内边距再补回来，保证卡内标签与上方字段左边严格对齐 */
#BoneAdd .section-block {
    /* -21px 补偿左右各 1px 边框，否则卡内标签比卡外字段右移 1px */
    margin: 0 -21px 18px;
    padding: 18px 20px 0;
    border: 1px solid #eef1f7;
    border-radius: 10px;
    background-color: #fcfdff;
}

#BoneAdd .user-info-list {
    margin-bottom: 14px;
}

/* 上传控件 */
#BoneAdd /deep/ .el-upload--picture-card {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 110px;
    height: 110px;
    line-height: 1;
    border: 1px dashed #d4dae6;
    border-radius: 10px;
    background-color: #fff;
    color: #9aa4b8;
    transition: border-color 0.2s, color 0.2s, background-color 0.2s;
}

#BoneAdd /deep/ .el-upload--picture-card:hover {
    border-color: #5680fa;
    color: #5680fa;
    background-color: rgba(86, 128, 250, 0.04);
}

/* 上传中隐藏新增按钮（自定义进度卡占位），需要盖过上面的 display: flex */
#BoneAdd .hide-add /deep/ .el-upload--picture-card {
    display: none;
}

#BoneAdd .up-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

#BoneAdd .up-slot i {
    margin-bottom: 6px;
    font-size: 22px;
}

#BoneAdd .up-slot span {
    font-size: 12px;
    line-height: 1.2;
}

/* 图片 / 视频上传区：整体 flex 布局，缩略图多行换行时两组上传块也不会错位 */
#BoneAdd .media-uploads {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

/* 每个 el-upload 根节点内部也用 flex 行排：缩略图 + 上传按钮 */
#BoneAdd .media-uploads > div {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 0 14px 0 0;
}

/* 上传按钮固定排在本组第一位：保证「上传图片」「上传视频」两张卡片始终同排对齐 */
#BoneAdd .media-uploads > div > .el-upload--picture-card {
    order: -1;
}

/* 视频上传中的占位卡紧跟在两组之后 */
#BoneAdd .media-uploads .video-uploading {
    order: 0;
    margin-right: 14px;
}

#BoneAdd .upload-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    color: #a2abbd;
}

#BoneAdd .upload-tips span {
    display: inline-block;
    margin-right: 18px;
}

#BoneAdd .upload-tips span:last-child {
    margin-right: 0;
}

/* 发布成功弹框（append-to-body，选择器不能带 #BoneAdd 前缀） */
.publish-dialog {
    border-radius: 16px;
    overflow: hidden;
}

.publish-dialog /deep/ .el-dialog__header,
.publish-dialog /deep/ .el-dialog__footer {
    display: none;
    padding: 0;
}

.publish-dialog /deep/ .el-dialog__body {
    padding: 32px 28px 28px;
    text-align: center;
}

.publish-success-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6d94ff 0%, #5680fa 100%);
    box-shadow: 0 6px 16px rgba(86, 128, 250, 0.35);
    color: #fff;
    font-size: 28px;
    line-height: 56px;
}

.publish-success-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: #2b3245;
}

.publish-success-tip {
    margin: 0 0 20px;
    font-size: 13px;
    color: #8a93a6;
}

/* 发布成功：二维码区域 */
.publish-success-qr {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    padding: 16px 0 10px;
}

.publish-success-qr /deep/ img,
.publish-success-qr /deep/ canvas {
    display: block;
    width: 200px;
    height: 200px;
}

.publish-success-qr-tip {
    margin: 0;
    color: #5a6478;
    font-size: 13px;
    text-align: center;
}

.publish-success-btn {
    width: 100%;
    margin-top: 20px;
    border-radius: 22px;
    background-color: #5680fa;
    border-color: #5680fa;
}

.publish-success-btn:hover,
.publish-success-btn:focus {
    background-color: #6d94ff;
    border-color: #6d94ff;
}

/* 既往用药：可添加的药物 + 时长 */
#BoneAdd .medication-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
#BoneAdd .medication-item {
    display: flex;
    align-items: center;
    gap: 12px;
}
#BoneAdd .medication-name {
    width: 260px;
    flex-shrink: 0;
}
#BoneAdd .medication-duration {
    flex: 1;
}
#BoneAdd .medication-duration /deep/ .el-input__inner {
    border-radius: 8px;
}
#BoneAdd .medication-delete {
    font-size: 18px;
    color: #909399;
    cursor: pointer;
    transition: color 0.2s;
}
#BoneAdd .medication-delete:hover {
    color: #f56c6c;
}
#BoneAdd .medication-add {
    align-self: flex-start;
    border-color: #5680fa;
    color: #5680fa;
}
#BoneAdd .medication-add:hover {
    background-color: rgba(86, 128, 250, 0.08);
}

/* 提示语图标：与文字垂直居中 */
#BoneAdd .upload-tips span i {
    margin-right: 4px;
    font-size: 13px;
    color: #9aa7bd;
}

#BoneAdd /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 110px;
    height: 110px;
    border-color: #e8ebf1;
    border-radius: 10px;
}

#BoneAdd /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
}

#BoneAdd /deep/ .el-upload__tip {
    margin-top: 8px;
    line-height: 18px;
    font-size: 12px;
    color: #a2abbd;
}

/* 暂存提示（左边距与 label-width 一致，内容区左边缘对齐） */
#BoneAdd .draft-tip {
    margin: 0 0 14px 180px;
    padding: 8px 12px;
    border-radius: 6px;
    background-color: #f5f8ff;
    font-size: 12px;
    color: #5680fa;
}

/* 底部操作区：吸底，长表单滚动时也能随时提交 */
#BoneAdd .action-bar {
    position: sticky;
    bottom: 0;
    z-index: 5;
    margin: 26px -32px -28px;
    padding: 16px 32px;
    border-top: 1px solid #f0f2f6;
    border-radius: 0 0 12px 12px;
    background-color: rgba(255, 255, 255, 0.96);
}

#BoneAdd .action-bar /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

#BoneAdd .action-bar /deep/ .el-button {
    height: 42px;
    padding: 0 28px;
    border-radius: 8px;
    font-size: 14px;
    transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

#BoneAdd .action-bar /deep/ .el-button + .el-button {
    margin-left: 12px;
}

#BoneAdd .action-bar /deep/ .el-button--primary.is-plain:hover {
    background-color: rgba(86, 128, 250, 0.08);
    border-color: #5680fa;
    color: #5680fa;
}

#BoneAdd .action-bar /deep/ .el-button--primary:hover,
#BoneAdd .action-bar /deep/ .el-button--primary:focus {
    background-color: #6d90fb !important;
    border-color: #6d90fb !important;
    box-shadow: 0 2px 10px 0 rgba(86, 128, 250, 0.35);
}

/* 弹窗 */
#BoneAdd /deep/ .el-dialog {
    border-radius: 10px;
    overflow: hidden;
}

#BoneAdd /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f2f6;
}

#BoneAdd /deep/ .el-dialog__title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2733;
}

#BoneAdd /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
}

#BoneAdd /deep/ .el-dialog__body {
    padding: 20px;
}

#BoneAdd .media-preview {
    min-height: 240px;
    padding: 4px;
}

#BoneAdd .media-preview img {
    max-height: 62vh;
    border-radius: 6px;
}

#BoneAdd .media-preview video {
    max-height: 62vh;
    border-radius: 6px;
}

/* 参考模板列表 */
#BoneAdd .scene-item:hover {
    border-color: #5680fa;
    background-color: #f5f8ff;
    box-shadow: 0 2px 10px 0 rgba(86, 128, 250, 0.12);
}

#BoneAdd .scene-name {
    font-weight: 500;
}
</style>
